import React from 'react';
import { DataDiff } from '../model/FestivalData';
import { useMessages } from '../i18n/I18n';

interface ConflictModalProps {
  diffs: DataDiff[];
  onOverwrite: () => void;
  onReload: () => void;
  onClose: () => void;
}

const ConflictModal: React.FC<ConflictModalProps> = ({
  diffs,
  onOverwrite,
  onReload,
  onClose,
}) => {
  const t = useMessages('editor');
  const common = useMessages('common');
  return (
    <div className="modal-overlay">
      <div className="modal-content conflict-modal">
        <h2>{t.conflictTitle}</h2>
        <p>{t.conflictNewerVersion}</p>
        
        <div className="diff-container">
          <h3>{t.conflictChanges}</h3>
          {diffs.map((diff, index) => (
            <div key={index} className={`diff-item diff-${diff.type}`}>
              <span className="diff-path">{diff.path}</span>
              {diff.type === 'modified' && (
                <>
                  <div className="diff-old">- {JSON.stringify(diff.oldValue)}</div>
                  <div className="diff-new">+ {JSON.stringify(diff.newValue)}</div>
                </>
              )}
              {diff.type === 'added' && (
                <div className="diff-new">+ {JSON.stringify(diff.newValue)}</div>
              )}
              {diff.type === 'removed' && (
                <div className="diff-old">- {JSON.stringify(diff.oldValue)}</div>
              )}
            </div>
          ))}
        </div>

        <div className="conflict-actions">
          <button onClick={onOverwrite} className="danger">
            {t.overwrite}
          </button>
          <button onClick={onReload} className="secondary">
            {t.reloadFromServer}
          </button>
          <button onClick={onClose} className="tertiary">
            {common.cancel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConflictModal; 